import { render, staticRenderFns } from "./Listado.vue?vue&type=template&id=69a711ea&scoped=true"
import script from "./Listado.vue?vue&type=script&lang=js"
export * from "./Listado.vue?vue&type=script&lang=js"
import style0 from "./Listado.vue?vue&type=style&index=0&id=69a711ea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a711ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69a711ea')) {
      api.createRecord('69a711ea', component.options)
    } else {
      api.reload('69a711ea', component.options)
    }
    module.hot.accept("./Listado.vue?vue&type=template&id=69a711ea&scoped=true", function () {
      api.rerender('69a711ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/otros-documentos/Listado.vue"
export default component.exports